import { ArrowLeftOutlined } from "@ant-design/icons";
import SearchLg from "@untitled-ui/icons-react/build/esm/SearchLg";
import {
  Button,
  Card,
  Form,
  Input,
  Pagination,
  Row,
  Spin,
  Table,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// import MainLayout from "../../../../components/layouts/MainLayout";
// import TopContent from "../../../../components/layouts/TopContent";
import { connect, useDispatch } from "react-redux";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import { rightAction } from "../../../../redux/actions";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
// import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import ArrowRight from "@untitled-ui/icons-react/build/esm/ArrowRight";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import { apiConfig, labelConfig, staticConfig } from "./wallet.config";

//global distructures
const { Text } = Typography;

const columns = [
  {
    title: "Nuban Number",
    dataIndex: "nubanNumber",
  },

  {
    title: "Name",
    dataIndex: "name",
    // sorter: (a, b) => a["accountNo"].localeCompare(b["accountNo"]),
  },
  {
    title: "Parent Name",
    dataIndex: "parentName",
    // sorter: (a, b) => a.clientName.localeCompare(b.clientName),
  },
  {
    title: "Product Name",
    dataIndex: "walletProductName",
    // sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
  {
    title: "KYC Level",
    dataIndex: "kycLevel",
  },
];

const ManageSavingsAccount = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;

  const { session } = userData;
  const [savingsAccountList, setSavingsAccountList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [walletAccountId, setWalletAccountId] = useState("");

  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [tableStatus, setTableStatus] = useState("Active");
  const [searchText, setSearchText] = useState("");

  //DECLARED METHODS

  useEffect(() => {
    {
      BOM.HasPermission("READ_SAVINGSACCOUNT") && getWalletAccount();
    }
    {
      BOM.HasPermission("CREATE_SAVINGSACCOUNT") &&
        rightAction(cnt.RIGHT_ADD_BTN);
    }
  }, []);

  const getWalletAccount = () => {
    setIsLoading(true);
    let body = {
      session,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, apiConfig.WalletAccount, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;
        let tempArray = [];

        console.log(objList);
        objList.forEach((element, i) => {
          console.log("Looping:", i, element);
          tempArray.push({
            key: element?.id,
            id: element?.id,
            nubanNumber: element?.nubanNumber || "-",
            walletProductName: element?.walletProductName || "-",
            parentName: element?.parentName || "-",
            name: element?.name || "-",
            kycLevel: element?.kycLevel.value || "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setSavingsAccountList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onSelectItemAction = (record, selected, selectedRows) => {
    console.log(record);
    if (!selected || selectedRows.length !== 1) {
      setSelectedRow(null);
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });

      BOM.HasPermission("CREATE_BOND") && dispatch({ type: cnt.RIGHT_ADD_BTN });
      return;
    }

    setSelectedRow(record);
    setWalletAccountId(record.id);

    [
      BOM.HasPermission("READ_LOANPRODUCT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_LOANPRODUCT") && cnt.RIGHT_EDIT_BTN,
    ].forEach((item) => {
      item &&
        dispatch({
          type: item,
        });
    });
  };

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-wallet-account", {
        state: {
          clientName: selectedRow.clientName,
          id: selectedRow.id,
          clientId: selectedRow.clientId,
          ...selectedRow.otherKeys,
        },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-wallet-account", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-wallet-account", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSearch = (formValue) => {
    setIsLoading(true);

    const params = {
      exactMatch: false,
      query: formValue.searchKey,
      resource: "savings,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // console.log(res);
        const objList = res;
        let tempArray = [];

        objList.forEach((element, i) => {
          console.log("Looping:", i, element);
          tempArray.push({
            nubanNumber: element?.nubanNumber || "-",
            walletProductName: element?.walletProductName || "-",
            parentName: element?.parentName || "-",
            name: element?.name || "-",
            kycLevel: element?.kycLevel.value || "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setSavingsAccountList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function handleSearchInTable(e) {
    setSearchKey(e.target.value);
  }

  const handleSelectOnChange = (value) => {
    // console.log(value);

    setTableStatus(value);
    setCurrentPage(1); // Reset to page 1 on filter change
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  const filteredData = savingsAccountList.filter((item) => {
    const search = searchKey.toLowerCase();
    return (
      item.nubanNumber.toLowerCase().includes(search) ||
      item.name.toLowerCase().includes(search) ||
      item.parentName.toLowerCase().includes(search) ||
      item.walletProductName.toLowerCase().includes(search) ||
      item.kycLevel.toLowerCase().includes(search)
    );
  });

  const totalPages = Math.ceil(filteredData.length / pageSize);

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      pageItems={staticConfig.walletItems}
    >
      <TopContent
        pageTitle={labelConfig.wallet}
        createPageTitle={labelConfig.accountListing}
      />

      {/* RENDER TABLE LIST */}
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search"
                prefix={<SearchLg width={18} color="#667085" />}
                style={{
                  width: 400,
                  borderRadius: "10px",
                }}
              />
            </div>

            {/* <DownloadTableButtons
              downloadData={savingsAccountList}
              columns={columns}
              fileName={"Wallet Account List"}
            /> */}
          </Row>

          <Table
            className="bond-table"
            rowSelection={{
              onSelect: onSelectItemAction,
              hideSelectAll: true,
            }}
            columns={columns}
            dataSource={filteredData}
            pagination={false}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            {/* Empty space on the left */}
            <div>
              <Button
                style={{
                  backgroundColor: "white",
                  borderRadius: 8,
                  border: "1px solid #D0D5DD",
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                className="previous-button"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                <ArrowLeftOutlined style={{ width: "20px", height: "20px" }} />{" "}
                Previous
              </Button>
            </div>

            {/* Centered Pagination */}
            <div style={{ flex: 1, textAlign: "center" }}>
              <Pagination
                current={currentPage}
                total={tableCount}
                pageSize={pageSize}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
                itemRender={itemRender}
                align="center"
              />
            </div>

            {/* Next button on the right */}
            <div>
              <Button
                style={{
                  backgroundColor: "white",
                  borderRadius: 8,
                  border: "1px solid #D0D5DD",
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                className="previous-button"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage >= totalPages}
              >
                Next <ArrowRight style={{ width: "20px", height: "20px" }} />
              </Button>
            </div>
          </div>
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageSavingsAccount);
